import axios from 'axios';
import Cookies from 'universal-cookie';
import { showErrorNotification, showInfoNotification } from '../Services/Notifications';
import { Constants } from './Constants';
const cookies = new Cookies();

export const Appheaders = () => ({
  'appid':1,
  'apptoken':'dgjfhsal12r49$sjdt23djksg9d'
});

export const CreateColumns = (columnNames) => {
  if (typeof columnNames !== 'object' && !columnNames.length) return [];
  return columnNames.map((item) => ({
    title: item,
    dataIndex: item,
    key: item,
  }));
};

export const getDocumentListing = async ({ setShowLoader, setListingData }) => {
  setShowLoader(true);
  try {
    let response = await fetch(Constants.BACKEND_API_URL + 'services/documents/listing', {
      method: 'GET',
      headers: headers(),
    });
    let jsonData;
    if (response.ok) {
      jsonData = await response.json(); // Return the blob promise
    } else {
      throw new Error('Network response was not ok.');
    }
    console.log(jsonData, 'jsonData'); // Handle the blob data here
    if (jsonData.responseCode == 200) {
      setListingData(jsonData.data);
    } else {
      showErrorNotification(jsonData.responseMessage);
    }
  } catch (error) {
    showErrorNotification(error.message);
    console.error('Fetch error:', error);
  }
  setShowLoader(false);
};

export const sendForEsign = ({ jsonData, setShowLoader, setListingData, is_resend = false,mode="email" }) => {
  setShowLoader(true);
  // Here you can define the logic to handle the merged file view
  let document_id = jsonData.document_id;
  fetch(process.env.REACT_APP_BACKEND_HOST + 'services/documents/esign', {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({
      type: 'pdf',
      document_id: document_id,
      is_resend: is_resend,
      mode:mode
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json(); // Return the blob promise
      } else {
        throw new Error('Problem while fetching the response. Please try after sometime.');
      }
    })
    .then((jsonData) => {
      setShowLoader(false); // Handle the blob data here
      if (jsonData.responseCode == 200) {
        showInfoNotification('Document has been sent for Esign.');
        getDocumentListing({ setShowLoader, setListingData });
      } else {
        showErrorNotification(jsonData.responseMessage);
      }
    })
    .catch((error) => {
      showErrorNotification(error.message);
      console.error('Fetch error:', error);
    });
};
export const checkDocument = ({ jsonData, setShowLoader, setListingData }) => {
  setShowLoader(true);
  // Here you can define the logic to handle the merged file view
  let document_id = jsonData.document_id;
  fetch(process.env.REACT_APP_BACKEND_HOST + 'services/documents/esign?document_id=' + document_id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json', // Set the appropriate content type
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json(); // Return the blob promise
      } else {
        throw new Error('Network response was not ok.');
      }
    })
    .then((jsonData) => {
      setShowLoader(false);
      if (jsonData.responseCode == 200) {
        if (!jsonData.self_signed_status) {
          showInfoNotification('The document is still in pending state, please ask user to esign the document.');
          return false;
        }
        getDocumentListing({ setShowLoader, setListingData });
      } else {
      }
    })
    .catch((error) => {
      setShowLoader(false);
      console.error('Fetch error:', error);
    });
};

export const downloadDocument = ({ jsonData, setShowLoader }) => {
  setShowLoader(true);
  // Here you can define the logic to handle the merged file view
  let document_id = jsonData.document_id;
  fetch(process.env.REACT_APP_BACKEND_HOST + 'services/documents/dowload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Set the appropriate content type
    },
    body: JSON.stringify({
      type: 'pdf',
      document_id: document_id,
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json(); // Return the blob promise
      } else {
        throw new Error('Network response was not ok.');
      }
    })
    .then((jsonData) => {
      setShowLoader(false);
      if (jsonData.responseCode == 200) {
        setTimeout(() => {
          window.open(jsonData.privateUrl, '_blank');
        }, 100);
      } else {
        showErrorNotification(jsonData.responseMessage);
      }
    })
    .catch((error) => {
      showErrorNotification(error.message);
      console.error('Fetch error:', error);
    });
};

export const viewMergedFile = ({ jsonData, setShowLoader }) => {
  setShowLoader(true);
  // Here you can define the logic to handle the merged file view
  fetch(process.env.REACT_APP_BACKEND_HOST + 'services/documents/view', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Set the appropriate content type
    },
    body: JSON.stringify({
      type: 'pdf',
      url: jsonData.merged_file,
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json(); // Return the blob promise
      } else {
        throw new Error('Network response was not ok.');
      }
    })
    .then((jsonData) => {
      setShowLoader(false);
      console.log(jsonData, 'jsonData'); // Handle the blob data here
      if (jsonData.responseCode == 200) {
        setTimeout(() => {
          window.open(jsonData.privateUrl, '_blank');
        }, 100);
      } else {
        showErrorNotification(jsonData.responseMessage);
      }
    })
    .catch((error) => {
      console.error('Fetch error:', error);
    });
};

//function to check whether the given time is greater than current time
export const isGreater = (givenDateTime) => {
  if (!givenDateTime)
    return true;
  const currentDateTime = new Date();

  const [givenDate, givenTime] = givenDateTime.split(' ');
  const [givenYear, givenMonth, givenDay] = givenDate.split('-').map(Number);
  const [givenHour, givenMinute, givenSecond] = givenTime.split(':').map(Number);

  const compareDateTime = new Date(
    givenYear,
    givenMonth - 1, // Months are 0-indexed
    givenDay,
    givenHour,
    givenMinute,
    givenSecond,
  );
  return compareDateTime < currentDateTime;
};

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
    .getDate()
    .toString()
    .padStart(2, '0')}`;

  const formattedTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;

  return `${formattedDate} ${formattedTime}`;
};

const commonKeys = (e) => {
  let ctrlDown = false;
  let ctrlKey = 17,
    vKey = 86,
    cKey = 67,
    rKey = 82;
  const specialKeys = [];
  specialKeys.push(8, 9, 46, 27, 13); // Allow: backspace, delete, tab, escape, enter
  const keyCode = e.which ? e.which : e.keyCode;
  if (e.ctrlKey) {
    ctrlDown = true;
  }
  return (specialKeys.indexOf(keyCode) != -1 ||
  // Allow: Ctrl
  keyCode === ctrlKey ||
  // Allow: Ctrl+A
  (keyCode === 65 && ctrlDown) ||
  // Allow: Ctrl+v
  (keyCode === vKey && ctrlDown) ||
  // Allow: Ctrl+c
  (keyCode === cKey && ctrlDown) ||
  // Allow: Ctrl+r
  (keyCode === rKey && ctrlDown) ||
  // Allow: home, end, left, right, down, up
  (keyCode >= 35 && keyCode <= 40));
}

export const setNumeric = (e) => {
  const ret =
    /[0-9. ]/.test(e.key) || commonKeys(e);
  if (!ret) {
    e.preventDefault();
  }
};

export const setEmailValidation = (event) => {
  const ret = /[a-zA-Z0-9@. ]/.test(event.key) || commonKeys(event);
  if (!ret) {
      event.preventDefault();
  }
};

export const setAlphaNumeric = (event) => {
  const ret = /[a-zA-Z0-9 ]/.test(event.key) || commonKeys(event);
  if (!ret) {
      event.preventDefault();
  }
};

export const setAlpha = (event) => {
  const ret = /[a-zA-Z ]/.test(event.key) || commonKeys(event);
  if (!ret) {
      event.preventDefault();
  }
};

export const panValidate = (pan) => pan.match(/^([a-zA-Z]){3}P([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$/);

const fetchAuthToken = () => {
  return 'Bearer ' + cookies.get('access_token');
};

export const headers = () => ({
  'Content-Type': 'application/json',
  'x-jwt': fetchAuthToken(),
});

export const getUserData = async (setUser, navigate) => {
  let response = await axios.get(Constants.BACKEND_API_URL + 'services/user/data', {
    headers: headers(),
  });
  response = response.data;
  if (response.responseCode !== 200) {
    cookies.remove('access_token');
    navigate('/login');
  }
  setUser(response.responseData);
};

/**
 * the function is to update the status of lead.
 */
export const UpdateLeadData = async (params) => {
  try {
    let url = `${Constants.COMMON_BACKEND_URL}rapi/quotation/${params.quotid}/${params.status}/${params.bankid}`;
    console.log("url", url);
    let options = {method: 'PUT'};
    options.headers = Appheaders();
    let response = await fetch(url, options);
    response = await response.json();
    return response;
  } catch(e) {
    console.log(e);
  } finally {

  }
}

export const formatAmountWithCommas = (amount) => {
  let parts = amount.toString().replace(/,/g, "").split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}